<template>
    <div class="notice04">
      <Nav :navSelectParent="1" />
    <div class='middle03'>
     <img :src="gxbg" alt="" class='gxbg'>
     <img :src="gxtitle" alt="" class='gxtitle'>
     <img :src="bgdi" alt="" class='bgdi'>
     <div class='feiji'>
         <h1 style='font-size:36px;color:#fff;margin-bottom:40px; text-align:center' class='biaot'>【光之圣境放置次元】四大阵容体系：水系·雷系·火系·风系</h1>
         <div class='dise'>
             <p>【水系】</p>
             <p>【命运之塔说明】</p>
             <p>大师梅林作为队伍核心，附加冰霜光环，使场上所有英雄攻击都有概率对目标附加结霜效果；</p>
             <p>魔装机神的减速，使敌方逐渐处于后手且伤害降低；</p>
             <p>普罗米修斯的冰封效果，给敌方造成巨大打击；</p>
             <p>伊西斯增加了阵容的持续战斗能力，并与利维坦凑成缘分，大大提高利维坦的输出能力；</p>
             <p>【雷系】</p>
             <p>海格力斯保护己方输出单位，为其分担伤害；</p>
             <p>3.报名时间内登录 自动报名。</p>
             <p>【干货——建议】</p>
             <p>本建议只对普通玩家，大佬不用管。</p>
             <p>玉藻前的额外伤害能力不断地削减敌方血量，同时还有自我保护能力；</p>
             <p>狩猎女神给敌方附加感电效果，加强对敌方伤害的同时，又为全体目标提升了防御；</p>
             <p>雷系众人超凡的保护能力的前提下，强力辅助通灵灯神的回复与持续回复能力，提高战斗能力；</p>
             <p>【火系】</p>
             <p>女神雅典娜用烈焰护盾反伤敌人，战神提尔和阿波罗大范围的焚烧，削弱对方的血线，携带焚烧的单位会使阿波罗的暴击能力大大提高；</p>
             <p>重生之翼分担了保护己方单位，尤其是阿波罗的职责，对敌方造成少量伤害；</p>
             <p>大主教提升了战神提尔的群体输出能力，也提升了前排单位的续航能力；</p>
             <p>【风系】</p>
             <p>大德鲁伊嘲讽敌方单位，保护己方队友；</p>
             <p>剑圣宫本武藏和洛基大量的控制效果，使敌方难以行动或损失大量的伤害能力；</p>
             <p>剑圣宫本武藏的无视防御和沙漠猫神配合，有减员敌方后排脆皮的能力；</p>
             <p>萤草的复活之翼可以让己方伤员死而复生，再次加入输出行列；</p>
         </div>
     </div>
    </div>
     <div class='gankebottom'>
        <div class='ganke'><img :src="ganke" alt=""></div>
        <div class='btnContent'>
          <div><p>未成年人家长监护工程&nbsp;&nbsp;</p><P>网络游戏出版物号（ISBN）ISBN 978-7-498-07262-7</P></div>
            <div><p>审批文号：国新出审[2020]174 号&nbsp;&nbsp;</p><a href='screct.html'>隐私协议 |&nbsp;&nbsp;</a><a href='https://sdk.djsh5.com/h5game/user/agreement.html'>用户协议 |&nbsp;&nbsp;</a><a href="https://sdk.djsh5.com/h5game/user/antiaddiction.html">防沉迷系统&nbsp;&nbsp;</a><P>来文文号：津新出字[2019]232 号</P></div>
            <div><p>地址：上海市徐汇区虹漕路88号越虹广场B座6楼&nbsp;&nbsp;</p><p>电话：021-64660150&nbsp;&nbsp;</p><P>Email：bd@gank-studio.com</P></div>
            <div><p>抵制不良游戏，拒绝盗z版游戏。 注意自我保护，谨防受骗上当。 适度游戏益脑，沉迷游戏伤身。 合理安排时间，享受健康生活。</p></div>
        </div>
     </div>
    </div>
  </template>
<script>
import Nav from '../components/nav.vue'
export default {
  name: 'notice04',
  components: {
    Nav
  },
  data () {
    return {
      ganke: require('../assets/ganke.png'),
      imgUrl: require('../assets/nav.png'),
      leftIcon: require('../assets/icon.png'),
      shouter: require('../assets/shouted.png'),
      introduction: require('../assets/introduction.png'),
      characteristic: require('../assets/characteristic.png'),
      gxbg: require('../assets/gxbg.png'),
      gxtitle: require('../assets/gxtitle.png'),
      bgdi: require('../assets/bgdi.png')
    }
  }
}
</script>

<style scoped>
.imgUrl {
  position:absolute;
  width:100%;
  height:88px;
  line-height:88px;
}
.row {
  display:flex;
  flex-direction:row;
  justify-content: space-around;
  align-items: center;
  height:88px;
  padding:0 10%;
  box-sizing: content-box;
}
.iconUl {
  display:flex;
  flex-direction:row;
  justify-content: space-around;
  align-items: center;
  box-sizing: content-box;
}
ul li {
  list-style: none;
}
.middle03 {
  position:relative;
}
.gxbg {
  position:relative;
  width:100vw;
}
.gxtitle {
    position:absolute;
    top:40%;
    left:50%;
    margin-left:-580px;
}
.bgdi {
    position:absolute;
    top:55%;
    left:50%;
    margin-left:-668px;
}
.feiji {
    position:absolute;
    top:60%;
    width:60%;
    left:20%;
}
.dise {
    width:100%;
    max-height:350px;
    overflow:scroll;
    background-color:#eee9e0;
    font-size:22px;
    color:#000;
    padding:30px 0
}
.dise p {
    display:block;
    line-height:42px;
    padding:0 25px;

}
.gankebottom {
  width:100vw;
  padding:50px 0;
  background-color:#000;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color:#fff;
  margin-top:-15px;
}
.btnContent {
  display:flex;
  flex-direction: column;
  justify-content: flex-start;
  font-size:18px;
}
.btnContent div {
  display:flex;
  flex-direction: row;
}
.btnContent a {
  color: rgb(250, 171, 25);
  cursor: pointer;
}
.ganke {
  margin-right:30px
}
.ganke img{
  width:152px;
  height:60px;
}
@media screen and (max-width: 1300px) {
  .bgdi {
    position: absolute;
    top: 55%;
    width: 80%;
    left: 63% !important;
    height: 525px !important;
}
.feiji {
  top:58%
}
.dise {
  height:300px;
  font-size:20px;
}
.biaot {
  font-size:30px !important;
  margin-bottom:10px !important
}
.gxtitle{
    position: absolute;
    top: 44%;
    left: 25%;
    width: 50%;
    margin-left:0
}
}
</style>



// WEBPACK FOOTER //
// src/pages/notice04.vue